/**
 * PocketFiler - Simplified Chinese (zh-CN) Translation File
 * Complete translation - all keys from en.js
 */

const zhCN = {
  "nav.login": "登录",
  "nav.signup": "开始使用",
  "nav.logout": "退出",
  "nav.dashboard": "仪表板",
  "nav.virtualOffices": "虚拟办公室",
  "nav.clients": "客户",
  "nav.deals": "交易",
  "nav.documents": "文档",
  "nav.messages": "消息",
  "nav.settings": "设置",
  "nav.invoices": "发票",
  "nav.templates": "模板",
  "nav.tasks": "任务",
  "nav.meetings": "会议",
  "nav.analytics": "分析",
  "landing.badge": "AI 驱动的交易平台",
  "landing.hero.title": "AI 管理的虚拟",
  "landing.hero.titleHighlight": "安全办公室",
  "landing.hero.subtitle": "PocketFiler 帮助企业和个人进行文档密集型、高信任度的交易——从全球贸易到本地汽车销售和保险政策——提供 AI 翻译、文档工作流程和每笔交易的交易室。",
  "landing.hero.cta.start": "免费开始",
  "landing.hero.cta.demo": "了解运作方式",
  "landing.useCases.title": "为全球贸易、本地服务和大型个人交易而建",
  "landing.useCases.subtitle": "无论您是从海外进口商品还是在城里卖车，PocketFiler 都能为您提供自信完成交易的工具。",
  "landing.useCases.globalTrade.title": "全球贸易与制造",
  "landing.useCases.globalTrade.desc": "查找并与海外供应商合作，收集合规文件，在交易室中进行实时翻译谈判。",
  "landing.useCases.insurance.title": "保险、贷款和专业服务",
  "landing.useCases.insurance.desc": "邀请客户用母语上传身份证、对账单和表格，然后在虚拟办公室中跟踪每份文档和消息。",
  "landing.useCases.realEstate.title": "房地产和物业交易",
  "landing.useCases.realEstate.desc": "用多种语言引导买家和租户完成申请、披露和合同，所有内容都在一个交易室中处理。",
  "landing.useCases.vehicle.title": "私人车辆和资产销售",
  "landing.useCases.vehicle.desc": "使用交易室和 AI 生成的合同来处理汽车、设备和其他高价值物品的买卖文档。",
  "landing.audience.title": "为个人和团队设计",
  "landing.audience.individuals.title": "个人用户",
  "landing.audience.individuals.bullet1": "清晰记录完成重要的一次性交易，如购买汽车、设备或高价值物品。",
  "landing.audience.individuals.bullet2": "使用简单安全的链接从手机上传文档和查看合同。",
  "landing.audience.individuals.bullet3": "将每笔交易的所有消息、文件和合同草稿保存在一个地方，即使交易完成后也是如此。",
  "landing.audience.teams.title": "企业和团队用户",
  "landing.audience.teams.bullet1": "为每条服务线（保险、房地产、贷款、进口）设置带有定制清单的虚拟办公室。",
  "landing.audience.teams.bullet2": "邀请任何语言的客户上传文档、签署合同并在交易室中沟通。",
  "landing.audience.teams.bullet3": "为团队提供共享工作空间，包含时间线、AI 摘要和每笔交易的完整历史记录。",
  "landing.howItWorks.title": "PocketFiler 如何为任何交易服务",
  "landing.howItWorks.subtitle": "四项强大功能协同工作，帮助您更快、更顺畅地完成交易。",
  "landing.howItWorks.concierge.title": "AI 助手",
  "landing.howItWorks.concierge.desc": "您的 AI 助手了解您的业务，设置正确的虚拟办公室，并为每种交易类型配置文档清单。",
  "landing.howItWorks.translation.title": "自动翻译",
  "landing.howItWorks.translation.desc": "消息和关键内容在各方之间即时翻译，让买家、卖家和客户可以用自己的语言交流。",
  "landing.howItWorks.documents.title": "智能文档",
  "landing.howItWorks.documents.desc": "客户从手机上传文档；AI 提取关键字段，检查质量，并在问题延迟交易之前标记它们。",
  "landing.howItWorks.dealRooms.title": "交易室和合同",
  "landing.howItWorks.dealRooms.desc": "每笔交易都有专门的房间，包含时间线、消息、文档和可供审核定稿的 AI 生成合同草稿。",
  "landing.cta.title": "准备好完成下一笔交易了吗？",
  "landing.cta.subtitle": "加入使用 PocketFiler 自信处理重要交易的企业和个人。",
  "landing.cta.button": "创建免费账户",
  "landing.footer.tagline": "让重要交易变简单。",
  "language.picker.title": "选择您的语言",
  "language.picker.subtitle": "我们将用这种语言向您展示所有说明、消息和合同。其他人可以选择自己的语言；AI 会为您处理翻译。",
  "language.picker.continue": "继续",
  "language.picker.playSample": "播放示例",
  "language.picker.playing": "播放中...",
  "language.picker.confirmation": "您选择了{language}。我们将用这种语言向您展示所有内容。其他方可以选择自己的语言；PocketFiler 会翻译消息、文档和合同，让每个人都能理解。",
  "language.toast.saved": "语言已保存！如需更改，请前往个人资料中的设置。",
  "language.confirm.title": "确认您的语言",
  "language.confirm.subtitle": "此语言将用于所有界面、消息和合同。",
  "language.confirm.change": "更改语言",
  "language.confirm.continue": "继续使用",
  "language.confirm.chineseNote": "注意：您选择了简体中文（简体中文）。如果您更喜欢繁体中文，请更改您的选择。",
  "auth.login.title": "欢迎回来",
  "auth.login.subtitle": "登录您的 PocketFiler 账户",
  "auth.login.email": "邮箱",
  "auth.login.password": "密码",
  "auth.login.submit": "登录",
  "auth.login.noAccount": "没有账户？",
  "auth.login.signupLink": "注册",
  "auth.login.error": "邮箱或密码无效",
  "auth.signup.title": "创建账户",
  "auth.signup.subtitle": "开始用任何语言完成交易",
  "auth.signup.name": "全名",
  "auth.signup.email": "邮箱",
  "auth.signup.password": "密码",
  "auth.signup.confirmPassword": "确认密码",
  "auth.signup.companyName": "公司名称",
  "auth.signup.companyType": "行业类型",
  "auth.signup.submit": "创建账户",
  "auth.signup.hasAccount": "已有账户？",
  "auth.signup.loginLink": "登录",
  "auth.signup.terms": "注册即表示您同意我们的服务条款和隐私政策。",
  "dashboard.title": "仪表板",
  "dashboard.welcome": "欢迎回来，{name}",
  "dashboard.aiSummary.title": "AI 摘要",
  "dashboard.aiSummary.generating": "正在生成摘要...",
  "dashboard.stats.totalDeals": "总交易数",
  "dashboard.stats.activeDeals": "活跃交易",
  "dashboard.stats.totalClients": "总客户数",
  "dashboard.stats.documentsProcessed": "已处理文档",
  "dashboard.recentDeals.title": "最近交易",
  "dashboard.recentDeals.viewAll": "查看全部",
  "dashboard.recentDeals.empty": "暂无交易。创建您的第一笔交易开始吧。",
  "dashboard.recentClients.title": "最近客户",
  "dashboard.recentClients.viewAll": "查看全部",
  "dashboard.recentClients.empty": "暂无客户。邀请您的第一位客户开始吧。",
  "dashboard.quickActions.title": "快速操作",
  "dashboard.quickActions.createDeal": "创建交易",
  "dashboard.quickActions.inviteClient": "邀请客户",
  "dashboard.quickActions.createOffice": "创建虚拟办公室",
  "offices.title": "虚拟办公室",
  "offices.subtitle": "按服务类型组织您的业务",
  "offices.create": "创建虚拟办公室",
  "offices.empty.title": "暂无虚拟办公室",
  "offices.empty.desc": "创建您的第一个虚拟办公室来组织交易和客户。",
  "offices.card.clients": "{count} 位客户",
  "offices.card.deals": "{count} 笔交易",
  "offices.card.checklist": "清单项目",
  "offices.checklist": "文档清单",
  "offices.noChecklist": "无需文档",
  "offices.dialog.title": "创建虚拟办公室",
  "offices.dialog.desc": "为特定服务类型设置新的工作空间",
  "offices.dialog.name": "办公室名称",
  "offices.dialog.namePlaceholder": "例如：保险理赔、房产销售",
  "offices.dialog.type": "办公室类型",
  "offices.dialog.description": "描述",
  "offices.dialog.descriptionPlaceholder": "描述此办公室处理的内容...",
  "offices.dialog.checklist": "文档清单",
  "offices.dialog.checklistHelp": "AI 生成的所需文档清单",
  "offices.dialog.addItem": "添加项目",
  "offices.dialog.generateChecklist": "AI 生成",
  "offices.dialog.creating": "创建中...",
  "offices.dialog.create": "创建办公室",
  "offices.form.name": "办公室名称",
  "offices.form.namePlaceholder": "例如：保险服务、房地产等",
  "offices.form.description": "描述",
  "offices.form.descPlaceholder": "此办公室将处理什么类型的交易？",
  "offices.form.checklistPlaceholder": "添加所需文档...",
  "offices.ai.title": "AI 辅助设置",
  "offices.ai.desc": "让我们的 AI 助手通过询问您的业务需求来帮助您设置完美的虚拟办公室。",
  "offices.ai.manual": "手动设置",
  "offices.ai.start": "开始 AI 设置",
  "offices.ai.startOnboarding": "帮我设置虚拟办公室",
  "offices.ai.suggestion": "AI 建议",
  "offices.ai.acceptSuggestion": "接受并创建办公室",
  "offices.ai.inputPlaceholder": "输入您的回复...",
  "clients.title": "客户",
  "clients.subtitle": "管理您的客户和邀请",
  "clients.invite": "邀请客户",
  "clients.empty.title": "暂无客户",
  "clients.empty.desc": "邀请您的第一位客户开始吧。",
  "clients.table.name": "姓名",
  "clients.table.client": "客户",
  "clients.table.contact": "联系方式",
  "clients.table.office": "办公室",
  "clients.table.language": "语言",
  "clients.table.status": "状态",
  "clients.table.actions": "操作",
  "clients.status.invited": "已邀请",
  "clients.status.active": "活跃",
  "clients.status.completed": "已完成",
  "clients.dialog.title": "邀请新客户",
  "clients.dialog.name": "客户姓名",
  "clients.dialog.email": "邮箱地址",
  "clients.dialog.phone": "电话号码",
  "clients.dialog.office": "虚拟办公室",
  "clients.dialog.language": "首选语言",
  "clients.dialog.sending": "发送邀请中...",
  "clients.dialog.send": "发送邀请",
  "clients.toast.invited": "邀请已发送给 {name}",
  "clients.toast.deleted": "客户已删除",
  "clients.toast.linkCopied": "邀请链接已复制到剪贴板",
  "clients.invite.step1Title": "邀请新客户",
  "clients.invite.step2Title": "预览邀请消息",
  "clients.invite.step3Title": "邀请已发送！",
  "clients.invite.step1Desc": "输入客户联系信息",
  "clients.invite.step2Desc": "审核并自定义邀请消息",
  "clients.invite.step3Desc": "与客户分享邀请链接",
  "clients.invite.nameLabel": "客户姓名",
  "clients.invite.namePlaceholder": "例如：张三",
  "clients.invite.contactMethod": "联系方式",
  "clients.invite.phone": "电话号码",
  "clients.invite.customNote": "自定义备注",
  "clients.invite.customNotePlaceholder": "此客户的特殊说明...",
  "clients.invite.previewMessage": "消息预览",
  "clients.invite.aiGenerated": "AI 生成的邀请消息",
  "clients.invite.messagePreview": "消息预览",
  "clients.invite.messageEditHint": "您可以在发送前编辑此消息",
  "clients.invite.documentsRequested": "请求的文档",
  "clients.invite.regenerate": "重新生成消息",
  "clients.invite.sendInvite": "发送邀请",
  "clients.invite.linkCreated": "邀请链接已创建！",
  "clients.invite.linkCopiedToClipboard": "链接已复制到剪贴板",
  "clients.invite.shareLink": "通过邮件、短信或当面与客户分享此链接",
  "clients.invite.inviteAnother": "邀请另一位",
  "clients.invite.success": "客户已邀请！",
  "clients.invite.linkCopied": "邀请链接已复制！",
  "clients.invite.yourAgent": "您的代理",
  "clients.invite.defaultOffice": "我们的办公室",
  "deals.title": "交易",
  "deals.subtitle": "跟踪和管理您的交易",
  "deals.create": "创建交易",
  "deals.empty.title": "暂无交易",
  "deals.empty.desc": "创建您的第一笔交易开始吧。",
  "deals.search": "搜索交易...",
  "deals.filter.all": "所有交易",
  "deals.filter.active": "活跃",
  "deals.filter.pending": "待处理",
  "deals.filter.closed": "已完成",
  "deals.column.draft": "草稿",
  "deals.column.active": "活跃",
  "deals.column.pending": "待处理",
  "deals.column.pending_documents": "待文档",
  "deals.column.pending_signature": "待签名",
  "deals.column.pending_payment": "待付款",
  "deals.column.escrow_funded": "已托管资金",
  "deals.column.release_requested": "请求放款",
  "deals.column.disputed": "有争议",
  "deals.column.on_hold": "暂停",
  "deals.column.completed": "进行中",
  "deals.column.cancelled": "已取消",
  "deals.column.closed": "已完成",
  "deals.card.documents": "{count} 份文档",
  "deals.card.messages": "{count} 条消息",
  "deals.dialog.title": "创建新交易",
  "deals.dialog.dealTitle": "交易标题",
  "deals.dialog.dealTitlePlaceholder": "例如：车辆购买 - 2023 本田思域",
  "deals.dialog.client": "客户",
  "deals.dialog.office": "虚拟办公室",
  "deals.dialog.type": "交易类型",
  "deals.dialog.notes": "备注",
  "deals.dialog.notesPlaceholder": "添加关于此交易的备注...",
  "deals.dialog.creating": "创建中...",
  "deals.dialog.create": "创建交易",
  "dealRoom.back": "返回交易",
  "dealRoom.readOnly.title": "只读",
  "dealRoom.readOnly.closedMessage": "此交易已完成。交易室现为只读状态，供参考和审计。",
  "dealRoom.readOnly.cancelledMessage": "此交易已取消。交易室现为只读状态，供参考和审计。",
  "dealRoom.tabs.messages": "消息",
  "dealRoom.tabs.documents": "文档",
  "dealRoom.tabs.contract": "合同",
  "dealRoom.timeline.title": "活动时间线",
  "dealRoom.timeline.empty": "暂无活动",
  "dealRoom.details.title": "交易详情",
  "dealRoom.details.notes": "备注",
  "dealRoom.details.type": "类型",
  "dealRoom.details.documents": "文档",
  "dealRoom.details.messages": "消息",
  "dealRoom.aiSummary.title": "AI 摘要",
  "dealRoom.aiSummary.generating": "正在生成摘要...",
  "dealRoom.messages.empty": "暂无消息。开始对话吧。",
  "dealRoom.messages.placeholder": "输入消息...",
  "dealRoom.messages.send": "发送",
  "dealRoom.messages.sending": "发送中...",
  "dealRoom.messages.showOriginal": "显示原文",
  "dealRoom.messages.showTranslation": "显示翻译",
  "dealRoom.messages.translatedFrom": "翻译自 {language}",
  "dealRoom.messages.suggestReply": "建议回复",
  "dealRoom.documents.empty": "暂无上传的文档。",
  "dealRoom.documents.upload": "上传文档",
  "dealRoom.documents.uploading": "上传中...",
  "dealRoom.documents.analyze": "分析",
  "dealRoom.documents.analyzing": "分析中...",
  "dealRoom.documents.download": "下载",
  "dealRoom.documents.delete": "删除",
  "dealRoom.documents.pending": "待分析",
  "dealRoom.documents.analyzed": "已分析",
  "dealRoom.documents.aiAnalysis": "AI 文档分析",
  "dealRoom.documents.type": "文档类型",
  "dealRoom.documents.confidence": "置信度",
  "dealRoom.documents.summary": "摘要",
  "dealRoom.documents.issues": "问题",
  "dealRoom.contract.empty.title": "尚未生成合同",
  "dealRoom.contract.empty.desc": "为此交易生成 AI 合同草稿。",
  "dealRoom.contract.generate": "生成合同草稿",
  "dealRoom.contract.regenerate": "重新生成合同",
  "dealRoom.contract.generating": "生成中...",
  "dealRoom.contract.aiLabel": "AI 生成的合同草稿",
  "dealRoom.contract.language": "语言",
  "dealRoom.contract.copy": "复制",
  "dealRoom.contract.copied": "已复制到剪贴板",
  "dealRoom.contract.type": "合同类型",
  "dealRoom.contract.generated": "已生成",
  "dealRoom.contract.languages": "语言",
  "dealRoom.contract.status": "状态",
  "dealRoom.contract.notice": "AI 文档分析：一个或多个条款在所选语言之间没有直接对应。我们使用了描述性语言。请仔细审查这些部分，必要时与对方确认。",
  "dealRoom.contract.dialog.title": "生成合同草稿",
  "dealRoom.contract.dialog.desc": "AI 将根据交易详情生成双语合同。",
  "dealRoom.contract.dialog.disclaimer": "这是供审核的 AI 生成草稿。签署前请咨询法律专业人士。",
  "dealRoom.contract.dialog.type": "合同类型",
  "dealRoom.contract.dialog.languages": "语言",
  "dealRoom.contract.dialog.languagesHelp": "为双语合同选择两种语言。所有一级语言均受完全支持。",
  "dealRoom.contract.dialog.primary": "主要",
  "dealRoom.contract.dialog.secondary": "次要",
  "dealRoom.contract.dialog.terms": "特殊条款",
  "dealRoom.contract.dialog.termsPlaceholder": "添加特殊条款或条件...",
  "dealRoom.contract.dialog.generate": "生成合同",
  "dealRoom.contract.dialog.generating": "生成中...",
  "dealRoom.status.change": "更改状态",
  "dealRoom.status.dialog.title": "更改交易状态",
  "dealRoom.status.dialog.from": "从",
  "dealRoom.status.dialog.to": "到",
  "dealRoom.status.dialog.reason": "原因（可选）",
  "dealRoom.status.dialog.reasonPlaceholder": "为什么要更改状态？",
  "dealRoom.status.dialog.confirm": "确认更改",
  "dealRoom.status.dialog.changing": "更改中...",
  "dealRoom.status.toast.changed": "状态已更改为 {status}",
  "dealRoom.upgrade.title": "升级到商业版",
  "dealRoom.upgrade.desc": "合同生成需要商业计划。",
  "dealRoom.upgrade.features": "使用商业版，您可以获得：",
  "dealRoom.upgrade.feature1": "AI 生成的合同草稿",
  "dealRoom.upgrade.feature2": "高级文档分析",
  "dealRoom.upgrade.feature3": "优先支持",
  "dealRoom.upgrade.button": "立即升级",
  "settings.title": "设置",
  "settings.subtitle": "管理您的账户和组织",
  "settings.tabs.profile": "个人资料",
  "settings.tabs.organization": "组织",
  "settings.profile.title": "个人资料设置",
  "settings.profile.subtitle": "管理您的个人信息",
  "settings.profile.name": "全名",
  "settings.profile.email": "邮箱",
  "settings.profile.emailNote": "邮箱无法更改",
  "settings.profile.language": "首选语言",
  "settings.profile.languageHelp": "所有界面、消息和合同都将以此语言显示。",
  "settings.profile.save": "保存更改",
  "settings.profile.saving": "保存中...",
  "settings.profile.saved": "个人资料已更新",
  "settings.org.title": "组织设置",
  "settings.org.subtitle": "管理您的业务信息",
  "settings.org.name": "组织名称",
  "settings.org.type": "行业类型",
  "settings.org.billingEmail": "账单邮箱",
  "settings.org.plan": "计划",
  "settings.org.verification": "验证状态",
  "settings.org.save": "保存更改",
  "settings.org.saving": "保存中...",
  "settings.org.saved": "组织已更新",
  "settings.org.noOrg": "未找到组织",
  "invite.language.title": "选择您的语言",
  "invite.language.subtitle": "我们将用您的语言显示所有说明。",
  "invite.welcome.title": "欢迎来到",
  "invite.welcome.subtitle": "我们已准备好接收您的文档。",
  "invite.welcome.time": "5-10 分钟",
  "invite.welcome.timeLabel": "预计时间",
  "invite.welcome.secure": "安全免费",
  "invite.welcome.secureDesc": "您的文档已加密。此服务对您免费。",
  "invite.welcome.start": "开始上传",
  "invite.documents.needed": "所需文档",
  "invite.upload.title": "上传文档",
  "invite.upload.dragDrop": "将文件拖放到此处，或点击选择",
  "invite.upload.or": "或",
  "invite.upload.takePhoto": "图片",
  "invite.upload.browse": "文件",
  "invite.upload.uploading": "上传中...",
  "invite.upload.analyzing": "正在检查文档...",
  "invite.upload.success": "上传成功",
  "invite.upload.next": "下一份文档",
  "invite.upload.finish": "全部审核",
  "invite.upload.skip": "暂时跳过",
  "invite.upload.progress": "进度",
  "invite.complete.title": "完成！",
  "invite.complete.subtitle": "您的文档已成功提交。",
  "invite.complete.message": "我们已收到您的所有文档。稍后会与您联系。",
  "invite.complete.summary": "已提交的文档",
  "invite.complete.securityNote": "您的文档已安全存储，仅授权人员可访问。",
  "invite.chat.title": "与您的代理聊天",
  "invite.chat.placeholder": "输入消息...",
  "invite.chat.empty": "暂无消息。开始对话吧。",
  "invite.chat.sent": "您的消息已发送。",
  "invite.chat.willRespond": "我们会尽快回复您。",
  "invite.chat.sending": "发送中...",
  "invite.error.title": "无效或过期的链接",
  "invite.error.message": "此邀请链接不再有效。请联系发送者获取新链接。",
  "common.loading": "加载中...",
  "common.save": "保存",
  "common.cancel": "取消",
  "common.delete": "删除",
  "common.edit": "编辑",
  "common.create": "创建",
  "common.close": "关闭",
  "common.dismiss": "关闭",
  "common.confirm": "确认",
  "common.back": "返回",
  "common.next": "下一步",
  "common.previous": "上一步",
  "common.of": "/",
  "common.search": "搜索",
  "common.filter": "筛选",
  "common.sort": "排序",
  "common.viewAll": "查看全部",
  "common.refresh": "刷新",
  "common.retry": "重试",
  "common.yes": "是",
  "common.no": "否",
  "common.or": "或",
  "common.and": "和",
  "common.optional": "可选",
  "common.required": "必填",
  "status.draft": "草稿",
  "status.active": "活跃",
  "status.pending": "待处理",
  "status.pending_documents": "待文档",
  "status.pending_signature": "待签名",
  "status.on_hold": "暂停",
  "status.closed": "已完成",
  "status.cancelled": "已取消",
  "error.generic": "出错了。请重试。",
  "error.network": "网络错误。请检查您的连接。",
  "error.unauthorized": "您无权执行此操作。",
  "error.notFound": "找不到请求的资源。",
  "error.validation": "请检查您的输入后重试。",
  "error.serverError": "服务器错误。请稍后重试。",
  "success.saved": "更改已成功保存。",
  "success.created": "创建成功。",
  "success.deleted": "删除成功。",
  "success.sent": "发送成功。",
  "success.uploaded": "上传成功。",
  "time.justNow": "刚刚",
  "time.minutesAgo": "{count} 分钟前",
  "time.hoursAgo": "{count} 小时前",
  "time.daysAgo": "{count} 天前",
  "time.today": "今天",
  "time.yesterday": "昨天",
  "dealRoom.notFound": "未找到交易",
  "dealRoom.loading": "加载交易中...",
  "dealRoom.conversation.title": "交易对话",
  "dealRoom.conversation.you": "您",
  "dealRoom.conversation.client": "客户",
  "dealRoom.messages.hideOriginal": "隐藏原文",
  "dealRoom.messages.original": "原文（{language}）",
  "dealRoom.messages.disabled": "此交易状态下消息已禁用",
  "dealRoom.messages.aiSuggest": "AI 建议回复",
  "dealRoom.documents.title": "文档",
  "dealRoom.documents.uploadDisabled": "上传已禁用",
  "dealRoom.documents.pendingAnalysis": "待分析",
  "dealRoom.documents.uploadFirst": "上传第一份文档",
  "dealRoom.documents.uploadHelp": "上传文档以进行 AI 分析",
  "dealRoom.documents.uploadDisabledHelp": "此交易状态下文档上传已禁用",
  "dealRoom.documents.analyzeWithAI": "AI 分析",
  "dealRoom.documents.notAnalyzed": "尚未分析",
  "dealRoom.documents.notAnalyzedHelp": "运行 AI 分析以提取文档类型、字段并获取见解",
  "dealRoom.documents.analyzeDocument": "分析文档",
  "dealRoom.documents.extractedFields": "提取的字段",
  "dealRoom.documents.issuesDetected": "检测到的问题",
  "dealRoom.documents.preview": "预览",
  "dealRoom.documents.uploaded": "已上传",
  "dealRoom.documents.deleteConfirm": "确定要删除此文档吗？",
  "dealRoom.onHold.message": "此交易已暂停。文档上传已禁用。您仍可发送消息进行协调。",
  "dealRoom.pendingSignature.message": "合同已准备好签署。在签署或撤销合同之前，文档上传已禁用。",
  "dealRoom.status.current": "当前",
  "dealRoom.status.finalWarning": "这是最终状态。此操作后交易无法重新打开。",
  "dealRoom.contract.purchaseAgreement": "购买协议",
  "dealRoom.contract.purchaseAgreementDesc": "标准购买协议合同",
  "dealRoom.contract.noContract": "暂无合同",
  "dealRoom.contract.noContractDesc": "根据交易详情和文档生成 AI 驱动的合同草稿。",
  "dealRoom.contract.notAvailable": "合同生成不适用于 {status} 交易。",
  "dealRoom.contract.locked": "等待签名期间合同生成已锁定。",
  "dealRoom.contract.requiresPlan": "需要商业入门计划",
  "dealRoom.toast.dealUpdated": "交易已更新",
  "dealRoom.toast.statusChanged": "交易状态已更改为 {status}",
  "dealRoom.toast.statusFailed": "更改状态失败",
  "dealRoom.toast.contractGenerated": "合同草稿生成成功",
  "dealRoom.toast.contractCopied": "{language} 合同已复制到剪贴板",
  "dealRoom.toast.messageFailed": "发送消息失败",
  "dealRoom.toast.suggestionFailed": "生成建议失败",
  "dealRoom.toast.documentUploaded": "文档已上传",
  "dealRoom.toast.uploadFailed": "上传失败",
  "dealRoom.toast.analysisComplete": "AI 文档分析完成",
  "dealRoom.toast.analysisFailed": "AI 分析失败",
  "dealRoom.toast.documentDeleted": "文档已删除",
  "dealRoom.toast.deleteFailed": "删除失败",
  "dealRoom.details.created": "创建时间",
  "dealRoom.details.addNotes": "添加交易备注...",
  "onboarding.brand": "PocketFiler",
  "onboarding.skip": "暂时跳过",
  "onboarding.badge": "AI 驱动设置",
  "onboarding.welcome": "欢迎，{name}！",
  "onboarding.welcomeGeneric": "欢迎！",
  "onboarding.subtitle": "让我们设置您的 PocketFiler 工作空间。告诉我们的 AI 助手您的业务，我们将为您配置一切。",
  "onboarding.step1": "描述您的业务和需求",
  "onboarding.step2": "AI 建议您的设置",
  "onboarding.step3": "开始管理交易",
  "onboarding.concierge.title": "AI 助手",
  "onboarding.toast.officeCreated": "虚拟办公室已创建！",
  "auth.signup.accountType": "账户类型",
  "auth.signup.passwordTooShort": "密码至少需要8个字符",
  "auth.signup.passwordsDoNotMatch": "密码不匹配",
  "auth.signup.success": "账户创建成功！",
  "captions.connecting": "连接中...",
  "captions.disable": "禁用字幕",
  "captions.enable": "启用字幕",
  "captions.error.connect": "连接字幕服务失败",
  "captions.error.toggle": "切换字幕失败",
  "captions.language": "字幕语言",
  "captions.live": "实时",
  "captions.off": "字幕关闭",
  "captions.on": "字幕开启",
  "captions.original": "原文",
  "captions.translated": "译文",
  "captions.translating": "翻译中...",
  "clients.joined.empty.desc": "您还未加入任何组织。请让他们邀请您加入其PocketFiler工作空间。",
  "clients.joined.empty.title": "未加入任何组织",
  "clients.nav.joinedOrgs": "已加入组织",
  "clients.nav.myClients": "我的客户",
  "clients.table.joinedDate": "加入日期",
  "clients.table.organization": "组织",
  "common.backToHome": "返回首页",
  "common.deleteConfirmDesc": "此操作无法撤销。这将永久删除该项目并从服务器中移除数据。",
  "common.deleteConfirmTitle": "确定要删除吗？",
  "common.noResults": "未找到结果",
  "connect.createAccount": "创建免费账户",
  "connect.dealCreated": "交易创建成功",
  "connect.error.invalid": "无效连接链接",
  "connect.error.invalidDesc": "此连接链接无效或已过期。",
  "connect.error.server": "出现问题",
  "connect.error.serverDesc": "请稍后重试。",
  "connect.infoUnauth": "此人使用PocketFiler安全管理跨语言交易和文档。",
  "connect.joinOffice": "加入虚拟办公室",
  "connect.loggedInAs": "已登录为",
  "connect.login": "登录",
  "connect.startDeal": "开始交易",
  "connect.titleAuth": "您正在连接",
  "connect.titleUnauth": "连接",
  "connect.typeOrg": "组织",
  "connect.typePerson": "个人",
  "contacts.actions.call": "通话",
  "contacts.actions.email": "邮件",
  "contacts.actions.message": "发送应用内消息",
  "contacts.actions.noEmail": "无邮箱地址",
  "contacts.actions.noPhone": "无电话号码",
  "contacts.actions.sms": "短信",
  "contacts.actions.title": "联系 {name}",
  "contacts.actions.whatsapp": "WhatsApp",
  "contacts.dialog.name": "联系人姓名",
  "contacts.dialog.title": "添加新联系人",
  "contacts.empty.desc": "添加您的第一个联系人开始使用。",
  "contacts.empty.title": "暂无联系人",
  "contacts.invite": "添加联系人",
  "contacts.invite.customNotePlaceholder": "关于此联系人的特别备注...",
  "contacts.invite.nameLabel": "联系人姓名",
  "contacts.invite.shareLink": "通过邮件、短信或当面与您的联系人分享此链接",
  "contacts.invite.step1Desc": "输入联系人信息",
  "contacts.invite.step1Title": "添加新联系人",
  "contacts.subtitle": "管理您的联系人和邀请",
  "contacts.table.contact": "联系人",
  "contacts.title": "联系人",
  "contacts.toast.deleted": "联系人已删除",
  "contacts.toast.invited": "联系人已添加：{name}",
  "contacts.toast.linkCopied": "链接已复制到剪贴板",
  "dashboard.quickActions.inviteContact": "添加联系人",
  "dashboard.recentContacts.empty": "暂无联系人。添加您的第一个联系人开始使用。",
  "dashboard.recentContacts.title": "最近联系人",
  "dashboard.recentContacts.viewAll": "查看全部",
  "dashboard.stats.totalContacts": "总联系人数",
  "dealRoom.contract.analysisWarning": "部分文档尚未分析。AI分析可提高合同准确性。",
  "dealRoom.conversation.colleague": "同事",
  "dealRoom.details.clients": "客户",
  "dealRoom.documents.previewNotAvailable": "预览不可用。下载中...",
  "dealRoom.incomingCall.accept": "接受",
  "dealRoom.incomingCall.decline": "拒绝",
  "dealRoom.incomingCall.inProgress": "通话进行中",
  "dealRoom.incomingCall.started": "{name}发起了通话",
  "dealRoom.messages.connecting": "连接聊天中...",
  "dealRoom.messages.connectionError": "无法连接对话。",
  "dealRoom.pendingSignature.loading": "加载签名状态中...",
  "dealRoom.pendingSignature.signedWaitingOthers": "签名成功。等待其他参与者。",
  "dealRoom.readOnly.completedMessage": "此交易已成功完成。交易室现为只读模式，供参考和审计使用。",
  "dealRoom.signature.signed": "已签名",
  "dealRoom.signature.signedByYou": "您已签名",
  "dealRoom.signature.success": "合同签名成功！",
  "dealRoom.signaturesList.clients": "客户",
  "dealRoom.signaturesList.dealOwner": "交易所有者",
  "dealRoom.signaturesList.pending": "待处理",
  "dealRoom.signaturesList.signedOn": "签名时间",
  "dealRoom.signaturesList.title": "签名",
  "dealRoom.signaturesList.viewSignatures": "查看签名",
  "dealRoom.signedByAll.addPayment": "添加付款",
  "dealRoom.signedByAll.message": "所有参与者已签名。进行付款。",
  "dealRoom.timeline.createdBy": "由 {name} 创建",
  "deals.tabs.all": "所有交易",
  "deals.tabs.my": "我的交易",
  "deals.validation.clientRequired": "请至少选择一个客户",
  "deals.validation.notesLength": "备注不能超过200个字符",
  "deals.validation.titleLength": "标题不能超过100个字符",
  "deals.validation.titleRequired": "交易标题必填",
  "documents.readAloud.analyzeFirst": "请先分析此文档以进行朗读。",
  "documents.readAloud.error": "朗读失败",
  "documents.readAloud.title": "朗读",
  "landing.cta.secondary": "查看示例交易室",
  "landing.hero.trust": "免费计划。无需信用卡。支持11种语言。",
  "landing.socialProof": "受到40个国家500+企业信赖",
  "landing.useCases.personal.desc": "通过清晰记录、AI合同和安全文档共享链接，完成重要的一次性交易，如车辆、设备或房产。",
  "landing.useCases.personal.title": "高价值个人交易",
  "landing.useCases.professional.desc": "邀请客户在AI助手协助下上传文档，在安全虚拟办公室中跟踪每次互动，并生成双语数字合同—一个工作空间完成所有操作。",
  "landing.useCases.professional.subtitle": "保险、房地产、借贷",
  "landing.useCases.professional.title": "专业服务",
  "livekit.call": "通话",
  "livekit.connecting": "连接中...",
  "livekit.error.connect": "连接通话失败。请重试。",
  "livekit.error.connection": "连接错误。请检查网络并重试。",
  "livekit.error.permission": "您没有加入此通话的权限。",
  "livekit.hint": "在此交易室内通话，无需切换应用。",
  "livekit.inCall": "通话中",
  "livekit.joinCall": "加入通话",
  "livekit.leaveCall": "离开通话",
  "livekit.participant": "参与者",
  "livekit.participants": "参与者",
  "messages.readAloud.error": "朗读失败",
  "messages.readAloud.title": "朗读",
  "nav.companyProfile": "公司资料",
  "nav.contacts": "联系人",
  "nav.directory": "目录",
  "nav.products": "产品",
  "offices.card.contacts": "{count}个联系人",
  "pwa.banner.install": "安装",
  "pwa.banner.subtitle": "更快访问，离线可用",
  "pwa.banner.title": "获取PocketFiler应用",
  "pwa.firefox.hint": "在Firefox中，寻找地址栏中的安装图标(⊕)将此应用添加到桌面。",
  "pwa.installApp": "安装应用",
  "pwa.installed": "应用安装成功！",
  "pwa.ios.description": "将PocketFiler添加到主屏幕获得最佳体验：",
  "pwa.ios.gotIt": "知道了",
  "pwa.ios.inToolbar": "在浏览器工具栏中",
  "pwa.ios.inTopRight": "右上角",
  "pwa.ios.shareButton": "分享按钮",
  "pwa.ios.step1": "点击",
  "pwa.ios.step2": "向下滚动并点击",
  "pwa.ios.step3": "点击",
  "pwa.ios.title": "安装PocketFiler",
  "pwa.iosHint": "点击分享图标和\\\"添加到主屏幕\\\"来安装PocketFiler。",
  "pwa.opera.chromeHint": "打开此页面，然后点击地址栏中的安装图标",
  "pwa.opera.desktopNotSupported": "Opera桌面版不支持PWA安装。要将PocketFiler安装为应用，请在Google Chrome或Microsoft Edge中打开。",
  "pwa.opera.edgeHint": "打开此页面，然后点击地址栏中的安装图标(⊕)",
  "pwa.opera.mobileAddPage": "添加页面到",
  "pwa.opera.mobileDescription": "点击Opera底部的+图标，或使用下面的菜单：",
  "pwa.opera.mobileHomeScreen": "主屏幕",
  "pwa.opera.mobileStep1": "点击",
  "pwa.opera.mobileStep1b": "Opera底部栏的加号(+)图标",
  "pwa.opera.mobileStep2": "或点击",
  "pwa.opera.mobileTitle": "在Opera中安装PocketFiler",
  "pwa.opera.recommendedBrowsers": "推荐使用：",
  "pwa.opera.title": "Opera中不可用",
  "qr.clickToExpand": "点击查看全屏",
  "qr.copied": "已复制！",
  "qr.copyLink": "复制链接",
  "qr.description": "向客户或合作伙伴展示此二维码。扫描后，他们可以与您建立连接并在几秒内开始交易。",
  "qr.download": "下载",
  "qr.generate": "生成二维码",
  "qr.linkCopied": "链接已复制到剪贴板",
  "qr.primaryLanguage": "主要语言",
  "qr.regenerate": "重置",
  "qr.regenerated": "二维码已重新生成。旧链接现已失效。",
  "qr.scanInstructions": "使用PocketFiler或任何二维码扫描器扫描此码建立连接。",
  "qr.scanToConnect": "扫码连接",
  "qr.share": "分享",
  "qr.title": "分享您的PocketFiler二维码",
  "qr.yourLink": "您的连接链接：",
  "recording.completed": "录制完成",
  "recording.confirmDelete": "删除此录制？",
  "recording.delete": "删除",
  "recording.deleted": "录制已删除",
  "recording.download": "下载",
  "recording.error.delete": "删除录制失败",
  "recording.error.noCall": "无活跃通话。请先加入通话。",
  "recording.error.start": "开始录制失败",
  "recording.error.stop": "停止录制失败",
  "recording.failed": "录制失败",
  "recording.noRecordings": "暂无录制",
  "recording.play": "播放",
  "recording.playback": "录制播放",
  "recording.processing": "处理中...",
  "recording.start": "录制",
  "recording.started": "录制开始",
  "recording.stop": "停止",
  "recording.stopped": "录制停止。处理中...",
  "recording.viewRecordings": "查看录制",
  "schedule.button": "预约",
  "schedule.cancel": "取消",
  "schedule.chooseDateTime": "请选择日期和时间",
  "schedule.create": "预约",
  "schedule.created": "已预约",
  "schedule.dateTime": "日期时间",
  "schedule.description": "选择日期和时间。到时您可以加入通话。",
  "schedule.title": "预约通话或录制",
  "schedule.type": "类型",
  "schedule.typeCall": "通话",
  "schedule.typeRecording": "录制",
  "schedule.upcoming": "即将到来的预约",
  "settings.profile.accountType": "账户类型",
  "settings.profile.accountTypeHelp": "选择最适合您的类型",
  "settings.tabs.sharing": "分享二维码",
  "support.askAI": "询问AI",
  "support.availableTimes": "可用时间",
  "support.booked": "通话预约成功！",
  "support.bookingConfirmed": "好的，我已为您安排在{time}的通话。您将收到包含通话链接的确认信息。还有其他我能帮助的吗？",
  "support.bookingError": "预约失败。请重试。",
  "support.clearChat": "清除对话",
  "support.error": "发送消息失败。请重试。",
  "support.inYourTime": "您的当地时间",
  "support.inputPlaceholder": "输入您的问题...",
  "support.openChat": "打开AI客服",
  "support.scheduleCall": "预约客服通话",
  "support.scheduleTitle": "预约客服通话",
  "support.slotsError": "加载可用时间失败。",
  "support.subtitle": "询问任何关于PocketFiler的问题",
  "support.title": "AI客服",
  "support.welcome": "您好！我是PocketFiler AI助手。我可以帮助您：\\n\\n- 创建和管理交易\\n- 发送文档进行签名\\n- 使用二维码连接功能\\n- 邀请客户\\n- 其他关于PocketFiler的问题\\n\\n今天我能为您做些什么？",
  "support.yourTimezone": "您的时区",
  "validation.emailInvalid": "邮箱格式无效",
  "validation.emailRequired": "邮箱必填",
  "validation.nameRequired": "姓名必填",
  "validation.nameTooLong": "姓名不能超过50个字符",
  "validation.noteTooLong": "备注不能超过200个字符",
  "validation.phoneInvalid": "电话号码无效(10-15位数字)",
  "validation.phoneRequired": "电话号码必填",
  "dashboard.actions.addClient": "添加客户",
  "dashboard.actions.all": "全部",
  "dashboard.actions.createContract": "创建合同",
  "dashboard.actions.createInvoice": "创建发票",
  "dashboard.actions.customize": "自定义",
  "dashboard.actions.newDeal": "新建交易",
  "dashboard.actions.scheduleMeeting": "安排会议",
  "dashboard.actions.uploadDocument": "上传文档",
  "dashboard.actions.viewAll": "查看全部",
  "dashboard.briefing.default": "目前没有紧急事项。您的工作区状态良好。",
  "dashboard.briefing.title": "每日简报",
  "dashboard.empty.activity": "没有最近活动。",
  "dashboard.empty.deals": "暂无交易。创建您的第一笔交易以查看管道。",
  "dashboard.empty.documents": "所有文档都是最新的。",
  "dashboard.empty.meetings": "没有即将到来的会议。",
  "dashboard.empty.tasks": "没有待办任务。",
  "dashboard.greeting.afternoon": "下午好",
  "dashboard.greeting.evening": "晚上好",
  "dashboard.greeting.morning": "早上好",
  "dashboard.greeting.subtitle": "以下是您工作区的最新动态。",
  "dashboard.stats.documents": "文档",
  "dashboard.stats.invoicesDue": "待付发票",
  "dashboard.stats.meetingsComing": "即将到来的会议",
  "dashboard.stats.tasksDue": "待办任务",
  "dashboard.stats.unreadMessages": "未读消息",
  "dashboard.widgets.dealPipeline": "交易管道",
  "dashboard.widgets.documentsAttention": "需要关注的文档",
  "dashboard.widgets.gettingStarted": "开始使用",
  "dashboard.widgets.quickActions": "快捷操作",
  "dashboard.widgets.recentActivity": "最近活动",
  "dashboard.widgets.tasks": "任务",
  "dashboard.widgets.upcomingMeetings": "即将到来的会议",
  "dashboard.steps.createDeal": "创建您的第一笔交易",
  "dashboard.steps.addClient": "添加客户",
  "dashboard.steps.uploadDocument": "上传文档",
  "dashboard.steps.scheduleMeeting": "安排会议",
  "dashboard.steps.createInvoice": "创建发票",
  "dashboard.steps.addLogo": "添加您的标志",
  "dashboard.steps.complete": "完成",
  "dashboard.time.overdue": "已逾期",
  "dashboard.time.today": "今天",
  "dashboard.time.tomorrow": "明天",
  "dashboard.time.noDate": "无日期",
  "dashboard.docReason.sent": "已发送，等待回复",
  "dashboard.docReason.notAnalyzed": "尚未分析",
  "dashboard.docReason.draft": "草稿，未完成",
  "dashboard.docReason.needsReview": "需要审核",
  "docViewer.notFound": "文档未找到",
  "docViewer.previewUnavailable": "此文件类型无法预览",
  "docViewer.aiAnalysis": "AI 分析",
  "docViewer.documentType": "文档类型",
  "docViewer.summary": "摘要",
  "docViewer.extractedFields": "提取字段",
  "docViewer.issues": "问题",
  "docViewer.tags": "标签",
  "docViewer.noPreviousVersions": "无历史版本",
  "docViewer.noActivity": "暂无活动",
  "auth.forgotPassword.title": "重置您的密码",
  "guestSign.loading": "正在加载合同...",
  "guestSign.unableToLoad": "无法加载合同",
  "guestSign.signed": "合同已签署",
  "guestSign.createOwn": "想要创建和管理您自己的合同吗？",
  "guestSign.secureSign": "安全签署",
  "meeting.ended": "此会议已结束",
  "meeting.cancelled": "会议已取消",
  "meeting.notFound": "会议未找到",
  "meeting.joiningAs": "加入身份",
  "meeting.yourName": "您的姓名 *",
  "meeting.emailOptional": "邮箱（可选）",
  "notFound.title": "页面未找到",
  "notFound.dashboard": "前往控制台",
  "notFound.home": "主页",
  "auth.resetPassword.invalidLink": "无效链接",
  "auth.resetPassword.title": "设置新密码",
  "templates.category": "类别",
  "templates.legal": "法务",
  "templates.sales": "销售",
  "templates.services": "服务",
  "templates.finance": "财务",
  "templates.library": "模板库",
  "templates.libraryDesc": "为您的业务提供即用型文档模板",
  "templates.noDefault": "没有默认模板匹配您的搜索条件。",
  "templates.noCustom": "未找到自定义模板",
  "templates.delete": "删除模板",
  "templates.cancel": "取消",
  "uploadRequest.notFound": "请求未找到",
  "uploadRequest.error": "出现错误",
  "uploadRequest.errorDesc": "请稍后重试或联系发送此请求的人员。",
  "uploadRequest.uploaded": "文档已上传！",
  "uploadRequest.title": "文档上传请求",
  "uploadRequest.fileTypes": "PDF、图片、Word 文档 - 最大 25MB",
  "verify.verifying": "正在验证您的邮箱...",
  "verify.success": "邮箱验证成功！",
  "verify.signIn": "登录",
  "verify.alreadyVerified": "已验证",
  "verify.invalidLink": "无效链接",
  "verify.backToLogin": "返回登录",
  "documents.documents": "文档",
  "documents.allStatus": "全部状态",
  "documents.newFolder": "新建文件夹",
  "documents.clear": "清除",
  "documents.noDocumentsYet": "暂无文档",
  "documents.status": "状态",
  "documents.type": "类型",
  "documents.uploadedBy": "上传者",
  "documents.previewNotAvailable": "预览不可用",
  "documents.aiAnalysis": "AI分析",
  "documents.documentType": "文档类型",
  "documents.summary": "摘要",
  "documents.extractedFields": "提取字段",
  "documents.issues": "问题",
  "documents.notYetAnalyzed": "尚未分析",
  "documents.details": "详情",
  "documents.size": "大小",
  "documents.date": "日期",
  "documents.mimeType": "MIME类型",
  "documents.noTags": "无标签",
  "documents.changeStatus": "更改状态",
  "documents.versionHistory": "版本历史",
  "documents.noPreviousVersions": "无历史版本",
  "documents.activityLog": "活动日志",
  "documents.noActivityRecordedYet": "暂无记录活动",
  "documents.uploadDocuments": "上传文档",
  "documents.dragAndDropFiles": "拖拽文件或点击浏览。支持PDF、图片、Word文档。",
  "documents.shareDocument": "共享文档",
  "documents.done": "完成",
  "documents.emailOptional": "邮箱（可选）",
  "documents.leaveEmptyToJust": "留空仅生成链接",
  "documents.messageOptional": "消息（可选）",
  "documents.cancel": "取消",
  "documents.requestDocuments": "请求文档",
  "documents.sendASecureUpload": "通过邮件向客户发送安全上传链接。",
  "documents.clientEmail": "客户邮箱 *",
  "documents.clientName": "客户姓名",
  "documents.requestedDocuments": "请求的文档 *",
  "documents.renameFolder": "重命名文件夹",
  "documents.selectADestinationFolder": "选择目标文件夹。",
  "documents.deleteDocument": "删除文档？",
  "settings.individual": "个人",
  "settings.business": "企业",
  "settings.buyer": "买方",
  "settings.seller": "卖方",
  "settings.chooseYourPreferredTheme": "选择您偏好的主题",
  "settings.light": "浅色",
  "settings.dark": "深色",
  "settings.system": "系统",
  "settings.manufacturing": "制造业",
  "settings.insurance": "保险业",
  "settings.realEstate": "房地产",
  "settings.automotive": "汽车业",
  "settings.importexport": "进出口",
  "settings.other": "其他",
  "settings.brandingWhitelabel": "品牌与白标",
  "settings.customizeThePocketfilerExperience": "为您的客户定制PocketFiler体验。",
  "settings.organizationLogo": "组织徽标",
  "settings.provideADirectLink": "提供透明PNG或SVG徽标的直接链接。",
  "settings.primaryThemeColor": "主要主题色",
  "settings.selectAHexColor": "选择代表您品牌主要色调的十六进制颜色代码。",
  "settings.accentHoverColor": "强调/悬停色",
  "settings.selectAHexColor1": "选择用于悬停状态、高亮和强调元素的十六进制颜色。",
  "settings.customDomain": "自定义域名",
  "settings.ensureYouConfigureA": "确保您配置指向pocketfiler.com的CNAME记录。",
  "settings.cancellationScheduled": "取消计划已安排",
  "settings.yourLastPaymentFailed": "您的上次付款失败。请更新付款方式以保持访问权限。",
  "settings.chooseYourPlan": "选择您的方案",
  "settings.monthly": "月付",
  "settings.save20": "节省20%",
  "settings.current": "当前",
  "settings.popular": "热门",
  "settings.contactSales": "联系销售",
  "settings.googleCalendar": "Google Calendar",
  "settings.syncYourPocketfilerMeetings": "将您的PocketFiler会议与Google Calendar同步",
  "settings.settingsPageErrorDebug": "设置页面错误（调试）",
  "invoices.createInvoice": "创建发票",
  "invoices.createANewInvoice": "为客户创建新发票",
  "invoices.selectClient": "选择客户",
  "invoices.dueDate": "到期日期",
  "invoices.clientName": "客户姓名",
  "invoices.clientEmail": "客户邮箱",
  "invoices.lineItems": "明细项目",
  "invoices.description": "描述",
  "invoices.qty": "数量",
  "invoices.price": "价格",
  "invoices.tax": "税率%",
  "invoices.total": "总计",
  "invoices.subtotal": "小计：",
  "invoices.discount": "折扣：",
  "invoices.tax1": "税费：",
  "invoices.total1": "总计：",
  "invoices.notesOptional": "备注（可选）",
  "invoices.invoices": "发票",
  "invoices.manageAndTrackYour": "管理和跟踪您的发票",
  "invoices.totalInvoiced": "总开票金额",
  "invoices.paid": "已付款",
  "invoices.outstanding": "未付款",
  "invoices.totalInvoices": "发票总数",
  "invoices.allInvoices": "全部发票",
  "invoices.myInvoices": "我的发票",
  "invoices.receivedInvoices": "已收到的发票",
  "invoices.noInvoicesYet": "暂无发票",
  "meetings.join": "加入",
  "meetings.end": "结束",
  "meetings.meetingTitle": "会议标题",
  "meetings.date": "日期",
  "meetings.time": "时间",
  "meetings.duration": "持续时间",
  "meetings.repeat": "重复",
  "meetings.doesNotRepeat": "不重复",
  "meetings.weekly": "每周",
  "meetings.every2Weeks": "每两周",
  "meetings.monthly": "每月",
  "meetings.invitePeopleOptional": "邀请人员（可选）",
  "meetings.cancel": "取消",
  "meetings.meetings": "会议",
  "companyprofile.companyProfile": "公司简介",
  "companyprofile.manageYourBusinessProfile": "管理您的企业简介和团队",
  "companyprofile.publicProfile": "公开简介",
  "companyprofile.basicInformation": "基本信息",
  "companyprofile.essentialDetailsAboutYour": "关于您公司的基本详情",
  "companyprofile.companyName": "公司名称",
  "companyprofile.tagline": "标语",
  "companyprofile.industry": "行业",
  "companyprofile.companyType": "公司类型",
  "companyprofile.description": "描述",
  "companyprofile.companyDetails": "公司详情",
  "companyprofile.additionalInformationAboutYour": "关于您企业的其他信息",
  "companyprofile.yearEstablished": "成立年份",
  "companyprofile.numberOfEmployees": "员工人数",
  "companyprofile.certifications": "认证",
  "companyprofile.enterCertificationsSeparatedBy": "请输入认证，用逗号分隔",
  "companyprofile.languagesSpoken": "使用语言",
  "companyprofile.shippingRegions": "配送区域",
  "companyprofile.contactInformation": "联系信息",
  "companyprofile.howPotentialPartnersCan": "潜在合作伙伴如何与您联系",
  "companyprofile.website": "网站",
  "companyprofile.email": "邮箱",
  "companyprofile.phone": "电话",
  "companyprofile.country": "国家",
  "companyprofile.city": "城市",
  "companyprofile.address": "地址",
  "companyprofile.teamMembers": "团队成员",
  "companyprofile.manageUsersWithinYour": "管理您组织内的用户",
  "companyprofile.role": "角色",
  "companyprofile.admin": "管理员",
  "companyprofile.member": "成员",
  "companyprofile.viewer": "查看者",
  "companyprofile.titleOptional": "职位（可选）",
  "companyprofile.name": "姓名",
  "companyprofile.title": "职位",
  "companyprofile.status": "状态",
  "companyprofile.actions": "操作",
  "companyprofile.owner": "所有者",
  "companyprofile.copyInviteLink": "复制邀请链接",
  "companyprofile.removeMember": "移除成员",
  "companyprofile.removeTeamMember": "移除团队成员",
  "companyprofile.cancel": "取消",
  "products.productsServices": "产品与服务",
  "products.description": "描述",
  "products.pricing": "定价",
  "products.price": "价格",
  "products.unit": "单位",
  "products.details": "详情",
  "products.minOrderQty": "最小订购量",
  "products.leadTime": "交货期",
  "products.category": "类别",
  "products.currency": "货币",
  "products.leadTimeDays": "交货期（天）",
  "products.active": "活跃",
  "products.showInCatalog": "在目录中显示",
  "products.cancel": "取消",
  "developersettings.reveal": "显示",
  "developersettings.copy": "复制",
  "developersettings.hide": "隐藏",
  "developersettings.securityWarning": "安全警告",
  "developersettings.neverShareThisKey": "切勿在公开场合或客户端代码中共享此密钥",
  "developersettings.anyoneWithThisKey": "拥有此密钥的任何人都可以读取和修改您的数据",
  "developersettings.ifCompromisedRevokeImmediately": "如密钥泄露，请立即撤销并生成新密钥",
  "developersettings.iUnderstandAndAccept": "我理解并承担此密钥安全的责任",
  "developersettings.cancel": "取消",
  "developersettings.revealKey": "显示密钥",
  "developersettings.accessDenied": "访问被拒绝",
  "developersettings.onlyBusinessAccountsHave": "只有企业账户可以访问开发者设置。",
  "developersettings.developerOverview": "开发者概览",
  "developersettings.manageYourApiKeys": "管理您的API密钥和Webhook端点，用于第三方集成。",
  "developersettings.secretApiKeys": "私有API密钥",
  "developersettings.interactiveApiDocumentationRarr": "交互式API文档 &rarr;",
  "developersettings.name": "名称",
  "developersettings.key": "密钥",
  "developersettings.createdAt": "创建时间",
  "developersettings.status": "状态",
  "developersettings.actions": "操作",
  "developersettings.webhookEndpoints": "Webhook端点",
  "developersettings.url": "URL",
  "developersettings.events": "事件",
  "developersettings.description": "描述",
  "developersettings.done": "完成",
  "developersettings.addWebhookEndpoint": "添加Webhook端点",
  "developersettings.payloadUrl": "负载 URL",
  "developersettings.eventsToSend": "要发送的事件",
  "developersettings.sendMeEverything": "发送全部内容 (*)",
  "developersettings.dealStatusChangedDealstatuschanged": "交易状态已更改 (deal.status_changed)",
  "developersettings.documentUploadedDocumentuploaded": "文档已上传 (document.uploaded)",
  "developersettings.descriptionOptional": "描述（可选）",
  "analytics.noDataAvailableFor": "此时间段内无可用数据。",
  "analytics.noDealsFound": "未找到交易。",
  "analytics.noClientDataAvailable": "此时间段内无客户数据可用。",
  "analytics.client": "客户",
  "analytics.invoices": "发票",
  "analytics.revenue": "收入",
  "analytics.totalPipeline": "总业务管道",
  "analytics.noRecentActivityFor": "此时间段内无近期活动。",
  "analytics.pipelineOverview": "业务管道概览",
  "analytics.goToDeals": "前往交易",
  "analytics.analyticsDashboard": "分析仪表板",
  "analytics.trackYourBusinessPerformance": "追踪您的业务绩效和洞察",
  "analytics.last7Days": "过去7天",
  "analytics.last30Days": "过去30天",
  "analytics.last90Days": "过去90天",
  "analytics.lastYear": "过去一年",
  "analytics.overview": "概览",
  "analytics.myPerformance": "我的绩效",
  "analytics.currentDealsByStatus": "按状态分类的当前交易",
  "analytics.revenueTrendsOverLast": "过去6个月的收入趋势",
  "analytics.accountsGeneratingTheMost": "产生最多收入的账户",
  "analytics.currentCashFlowOverview": "当前现金流概览",
  "analytics.latestBusinessActivitiesAnd": "最新业务活动和更新",
  "compliance.complianceCenter": "合规中心",
  "compliance.hsCodesTariffsSanctions": "HS编码、关税、制裁筛查和出口管制",
  "compliance.hsCodeClassification": "HS编码分类",
  "compliance.productDescription": "产品描述",
  "compliance.tariffCalculator": "关税计算器",
  "compliance.estimateImportDutiesBased": "基于HS编码和贸易路线估算进口关税。",
  "compliance.hsCode": "HS编码",
  "compliance.declaredValueUsd": "申报价值（美元）",
  "compliance.originCountry": "原产国",
  "compliance.destinationCountry": "目的国",
  "compliance.dutyRate": "关税税率：",
  "compliance.totalRate": "总税率：",
  "compliance.estDuty": "预估关税：",
  "compliance.totalEstCost": "总预估成本：",
  "compliance.tradeAgreements": "贸易协定：",
  "compliance.sanctionsScreening": "制裁筛查",
  "compliance.screenEntitiesAgainstOfac": "对照OFAC SDN名单和国家制裁清单筛查实体。",
  "compliance.entityName": "实体名称",
  "compliance.type": "类型",
  "compliance.company": "公司",
  "compliance.individual": "个人",
  "compliance.vessel": "船舶",
  "compliance.countryOptional": "国家（可选）",
  "compliance.usSanctionedCountries": "美国制裁国家",
  "compliance.exportControlCheck": "出口管制检查",
  "compliance.aipoweredEaritarClassificationGuidance": "AI驱动的EAR/ITAR分类指导。非法律建议。",
  "compliance.producttechnologyDescription": "产品/技术描述",
  "compliance.hsCodeOptional": "HS编码（可选）",
  "compliance.endUseOptional": "最终用途（可选）",
  "compliance.licenseRequired": "需要许可证",
  "compliance.recommendations": "建议：",
  "compliance.complianceHistory": "合规历史",
  "compliance.recentComplianceChecksFor": "您组织的近期合规检查。",
  "compliance.noComplianceChecksYet": "尚无合规检查。请在上方运行您的首次检查。",
  "intelligence.marketIntelligence": "市场情报",
  "intelligence.anonymizedTradeDataAnd": "来自PocketFiler平台的匿名化贸易数据和基准",
  "intelligence.demandByCategory": "按类别分类的需求",
  "intelligence.whatBuyersAreSourcing": "买家在平台上采购的商品（过去90天）",
  "intelligence.noDemandDataYet": "尚无需求数据。数据将随着平台上RFQ的创建而填充。",
  "intelligence.byIndustry": "按行业",
  "intelligence.noSupplierDataYet": "尚无供应商数据。",
  "intelligence.byCountry": "按国家",
  "intelligence.byType": "按类型",
  "intelligence.byVerification": "按验证状态",
  "intelligence.noDataYet": "尚无数据。",
  "intelligence.yourPerformanceVsPlatform": "您的绩效与平台对比",
  "intelligence.seeHowYouStack": "查看您与平台平均水平的对比",
  "intelligence.completeSomeDealsTo": "完成一些交易以查看基准。",
  "virtualoffices.virtualOffices": "虚拟办公室",
  "virtualoffices.manageYourBrandedWorkspaces": "管理您的品牌工作空间",
  "virtualoffices.officeName": "办公室名称",
  "virtualoffices.industry": "行业",
  "virtualoffices.languagesServed": "服务语言",
  "virtualoffices.descriptionOptional": "描述（可选）",
  "virtualoffices.documentChecklist": "文档清单",
  "virtualoffices.languages": "语言",
  "tasks.tasks": "任务",
  "tasks.noTasksYet": "尚无任务",
  "tasks.dragTasksHere": "将任务拖到此处",
  "tasks.createNewTask": "创建新任务",
  "tasks.descriptionOptional": "描述（可选）",
  "tasks.relatedDealOptional": "相关交易（可选）",
  "tasks.noDealAttached": "未关联交易",
  "tasks.assignees": "分配人员",
  "tasks.noTeamMembersAvailable": "无可用团队成员。只能分配给活跃成员。",
  "tasks.cancel": "取消",
  "tasks.description": "描述",
  "tasks.status": "状态",
  "tasks.relatedDeal": "相关交易",
  "tasks.noAssignees": "未分配人员",
  "tasks.areYouAbsolutelySure": "您确定要这样做吗？",
  "events.events": "活动",
  "events.tradeShowsWebinarsAnd": "贸易展览、网络研讨会和网络活动",
  "events.createEvent": "创建活动",
  "events.title": "标题",
  "events.description": "描述",
  "events.category": "类别",
  "events.type": "类型",
  "events.locationUrl": "位置 / URL",
  "events.startDateTime": "开始日期和时间",
  "events.endDateTime": "结束日期和时间",
  "events.maxAttendeesOptional": "最大参与人数（可选）",
  "events.cancel": "取消",
  "events.allCategories": "所有类别",
  "events.noEventsFoundCreate": "未找到活动。创建第一个吧！",
  "events.featured": "精选",
  "events.previous": "上一页",
  "events.next": "下一页",
  "status.pendingDocuments": "待提交文档",
  "status.pendingSignature": "待签署",
  "status.pendingPayment": "待付款",
  "status.completed": "已完成",
  "status.updated": "已更新",
  "status.onHold": "暂停",
  "activity.deal": "交易",
  "activity.action.analyzed": "已分析",
  "activity.action.uploaded": "已上传",
  "activity.action.downloaded": "已下载",
  "activity.action.previewed": "已预览",
  "activity.action.shared": "已分享",
  "activity.action.status_changed": "状态已更改",
  "activity.action.updated": "已更新",
  "activity.action.created": "已创建",
  "activity.action.archived": "已归档",
  "activity.action.restored": "已恢复",
  "analytics.totalRevenue": "总收入",
  "analytics.totalDeals": "总交易数",
  "analytics.conversionRate": "转化率",
  "analytics.avgDealValue": "平均交易价值",
  "analytics.dealPipeline": "交易渠道",
  "analytics.monthlyRevenue": "月收入",
  "analytics.topClientsByRevenue": "按收入排名的顶级客户",
  "analytics.invoiceHealth": "发票健康状况",
  "analytics.paid": "已付款",
  "analytics.pendingPayment": "待付款",
  "companyprofile.saveProfile": "保存档案",
  "companyprofile.makeVisible": "使您的公司在目录中可见",
  "companyprofile.tab.basicInfo": "基本信息",
  "companyprofile.tab.details": "详细信息",
  "companyprofile.tab.contact": "联系方式",
  "companyprofile.tab.team": "团队",
  "companyprofile.tab.verification": "验证",
  "companyprofile.selectType": "选择类型",
  "companyprofile.describePlaceholder": "描述您的公司、产品和服务...",
  "companyprofile.industry.other": "其他",
  "companyprofile.preview": "预览",
  "companyprofile.ph.companyName": "Your Company Inc.",
  "companyprofile.ph.tagline": "优质产品，全球覆盖",
  "companyprofile.ph.selectIndustry": "选择行业",
  "companyprofile.ph.selectSize": "选择规模",
  "companyprofile.ph.certifications": "ISO 9001, CE, FDA (用逗号分隔)",
  "companyprofile.ph.languages": "英语，西班牙语，中文",
  "companyprofile.ph.exportRegions": "北美，欧洲，亚洲",
  "companyprofile.ph.selectCountry": "选择国家",
  "companyprofile.ph.city": "洛杉矶",
  "companyprofile.ph.teamName": "团队成员姓名",
  "companyprofile.ph.addTitle": "添加职位...",
  "companyprofile.inviteTeamMember": "邀请团队成员",
  "companyprofile.invitationSent": "邀请发送成功",
  "virtualoffices.newOffice": "新建办公室",
  "virtualoffices.createOffice": "创建虚拟办公室",
  "virtualoffices.reviewChecklist": "审查文档清单",
  "virtualoffices.setupDesc": "为您的业务建立新的品牌工作空间",
  "virtualoffices.customizeDesc": "定制您需要客户提供的文档",
  "virtualoffices.ph.officeName": "例如：Garcia保险 - 汽车保单",
  "virtualoffices.ph.description": "描述您的办公室重点...",
  "virtualoffices.ph.addDocument": "添加自定义文档...",
  "virtualoffices.generating": "正在生成...",
  "virtualoffices.aiChecklist": "AI生成的清单",
  "virtualoffices.clients": "客户",
  "virtualoffices.pending": "待处理",
  "virtualoffices.invite": "邀请",
  "virtualoffices.ind.manufacturing": "制造业",
  "virtualoffices.ind.insurance": "保险",
  "virtualoffices.ind.real_estate": "房地产",
  "virtualoffices.ind.automotive": "汽车",
  "virtualoffices.ind.import_export": "进出口",
  "virtualoffices.ind.other": "其他",
  "messages.conversations": "会话",
  "messages.searchPlaceholder": "搜索消息...",
  "messages.noConversations": "暂无会话",
  "messages.send": "发送",
  "messages.selectConversation": "选择会话",
  "messages.selectConversationDesc": "从侧边栏中选择一个会话以开始聊天",
  "messages.support": "支持",
  "messages.client": "客户",
  "messages.deal": "交易",
  "meetings.subtitle": "安排和管理视频会议",
  "meetings.upcoming": "即将开始",
  "meetings.past": "已结束",
  "meetings.schedule": "安排",
  "meetings.startInstant": "立即开始",
  "meetings.startNow": "立即开始",
  "meetings.noPast": "无已结束的会议",
  "meetings.noUpcoming": "无即将开始的会议",
  "meetings.createMeeting": "创建会议",
  "meetings.startInstantMeeting": "开始即时会议",
  "meetings.scheduleMeeting": "安排会议",
  "meetings.scheduleDesc": "安排视频会议并发送邀请。",
  "meetings.invitePeople": "邀请人员（可选）",
  "meetings.15min": "15分钟",
  "meetings.30min": "30分钟",
  "meetings.45min": "45分钟",
  "meetings.allowRecording": "允许录制",
  "meetings.recordingDesc": "允许主持人录制此会议",
  "meetings.waitingRoom": "等候室",
  "meetings.waitingRoomDesc": "参与者必须经主持人批准后方可加入",
  "meetings.emailPlaceholder": "email@example.com",
  "meetings.cancelConfirm": "取消此会议？",
  "meetings.cancelMeeting": "取消会议",
  "documents.title": "文档",
  "documents.viewAll": "查看全部",
  "documents.archived": "已归档",
  "documents.requestDocs": "请求文档",
  "documents.upload": "上传",
  "documents.allDocuments": "所有文档",
  "documents.searchPlaceholder": "搜索文档...",
  "documents.addTag": "添加标签...",
  "documents.uploadDesc": "拖拽文件或点击浏览。支持PDF、图片、Word文档。",
  "documents.emailPlaceholder": "client@example.com",
  "documents.shareMsgPlaceholder": "这是您请求的文档...",
  "documents.requestDesc": "通过邮件向客户发送安全上传链接。",
  "documents.namePlaceholder": "张三",
  "documents.requestMsgPlaceholder": "请上传以下文档...",
  "documents.folderName": "文件夹名称",
  "documents.selectDestination": "选择目标文件夹。",
  "documents.statusUploaded": "已上传",
  "documents.statusAnalyzed": "已分析",
  "documents.statusArchived": "已归档",
  "documents.allTypes": "所有类型",
  "documents.inArchive": "在归档中",
  "templates.allTemplates": "所有模板",
  "templates.editTemplate": "编辑模板",
  "templates.createCustomTemplate": "创建自定义模板",
  "templates.editDesc": "更新您的文档模板",
  "templates.createDesc": "创建您自己的可重复使用文档模板",
  "templates.ph.templateName": "例如：自定义保密协议",
  "templates.ph.description": "模板的简要描述",
  "templates.ph.content": "请在此处输入您的模板内容...",
  "templates.saving": "保存中...",
  "templates.creating": "创建中...",
  "templates.saveChanges": "保存更改",
  "templates.createTemplate": "创建模板",
  "templates.searchPlaceholder": "搜索模板...",
  "templates.popularTemplates": "热门模板",
  "templates.defaultTemplates": "默认模板",
  "templates.deleteTemplate": "删除模板",
  "templates.preview": "预览",
  "templates.description": "描述",
  "products.searchPlaceholder": "搜索产品...",
  "products.ph.service": "咨询服务",
  "products.ph.product": "Widget Pro 3000",
  "products.selectCategory": "选择类别",
  "products.ph.describe": "描述您的产品或服务...",
  "products.noMatches": "未找到匹配结果",
  "products.noProducts": "暂无产品或服务",
  "products.serviceDetails": "服务详情",
  "products.productDetails": "产品详情",
  "products.inactive": "未启用",
  "products.deleteConfirm": "删除此项目？",
  "products.saveChanges": "保存更改",
  "products.addItem": "添加项目",
  "products.priceOnRequest": "面议",
  "products.perUnit": "每单位",
  "tasks.searchPlaceholder": "搜索任务...",
  "tasks.ph.title": "例如：审查法律文件",
  "tasks.ph.description": "为此任务添加更多说明...",
  "tasks.selectDeal": "选择要关联的交易",
  "tasks.noTasks": "此列中无任务",
  "tasks.deleteTask": "删除任务",
  "settings.tabs.branding": "品牌设置",
  "settings.tabs.payments": "付款",
  "settings.tabs.plan": "套餐",
  "settings.tabs.integrations": "集成",
  "settings.appearance": "外观",
  "settings.saveBranding": "保存品牌设置",
  "settings.yourPlan": "您的套餐",
  "settings.ph.logoUrl": "https://example.com/logo.png",
  "settings.ph.customDomain": "deals.yourcompany.com",
  "settings.calendarFeedGenerated": "日历订阅链接已生成！",
  "settings.plan.free": "免费版",
  "settings.plan.pro": "专业版",
  "settings.plan.smallBusiness": "小企业版",
  "settings.plan.businessPro": "商业专业版",
  "settings.plan.scale": "扩展版",
  "settings.plan.enterprise": "企业版",
  "dealroom.meetings": "会议",
  "dealroom.startMeeting": "开始会议",
  "dealroom.noMeetings": "此交易尚未关联任何会议",
  "dealroom.noMeetingsDesc": "开始会议或安排会议以开始",
  "dealroom.failedCreateMeeting": "创建会议失败",
  "dealroom.finalizedContract": "已完成合同 — 准备签署",
  "dealroom.previewNotSupported": "不支持预览",
  "dealroom.aiMayTakeMoment": "这可能需要一些时间。",
  "dealroom.aiAnalysisGenerated": "已为以下文档生成AI分析：",
  "dealroom.docsUnanalyzed": "以下文档仍未分析：",
  "dealroom.analyzingDocs": "正在分析文档...",
  "dealroom.finalizeWarning": "此操作无法撤销。交易状态将更改为待签署，所有相关方将能够签署合同。",
  "dealroom.cannotRevert": "无法从待签署状态恢复",
  "compliance.ph.productDesc": "例如，不锈钢螺栓，M10 x 50mm...",
  "compliance.ph.exportDesc": "描述正在出口的产品或技术...",
  "compliance.select": "选择...",
  "compliance.selectCountry": "选择国家...",
  "events.tradeShow": "贸易展览",
  "events.webinar": "网络研讨会",
  "events.networking": "商务交流",
  "events.conference": "会议",
  "events.workshop": "研讨会",
  "events.ph.title": "活动标题",
  "events.ph.location": "会场地址或会议网址",
  "events.ph.maxAttendees": "留空表示无限制",
  "events.searchPlaceholder": "搜索活动...",
  "events.cancelRsvp": "取消RSVP",
  "events.rsvp": "RSVP",
  "rfq.expired": "已过期",
  "rfq.createRfq": "创建报价请求",
  "rfq.visibility": "可见性",
  "rfq.public": "公开 - 所有供应商可见",
  "rfq.private": "私有 - 仅限邀请",
  "rfq.quantity": "数量",
  "rfq.unit": "单位",
  "rfq.pieces": "件",
  "rfq.kilograms": "千克",
  "rfq.meters": "米",
  "rfq.squareMeters": "平方米",
  "rfq.units": "单位",
  "rfq.sets": "套",
  "rfq.boxes": "箱",
  "rfq.deliveryLocation": "交货地点",
  "rfq.deliveryDeadline": "交货期限",
  "rfq.specialRequirements": "特殊要求",
  "rfq.title": "询价请求",
  "rfq.subtitle": "浏览采购请求或发布您自己的请求",
  "rfq.rfqsPosted": "已发布的RFQ",
  "rfq.openRfqs": "开放的RFQ",
  "rfq.quotesSent": "已发送报价",
  "rfq.winRate": "成功率",
  "rfq.allCategories": "所有类别",
  "rfq.noRfqsFound": "未找到RFQ",
  "rfq.noRfqsYet": "暂无RFQ",
  "meetings.biweekly": "每两周",
  "meetings.cancelSeries": "取消整个系列",
  "meetings.cancelThisMeeting": "取消此会议",
  "meetings.nextInSeries": "系列中的下一个",
  "nav.contractTemplates": "合同",
  "contracts.title": "合同模板",
  "contracts.subtitle": "AI驱动的法律文件生成。选择模板开始使用。",
  "documents.create": "创建",
  "createDoc.untitledDocument": "无标题文档",
  "createDoc.save": "保存",
  "createDoc.export": "导出",
  "createDoc.aiAssist": "AI助手",
  "createDoc.generate": "生成",
  "createDoc.generating": "生成中...",
  "createDoc.cancel": "取消",
  "createDoc.translate": "翻译",
  "createDoc.translateTitle": "翻译文档",
  "createDoc.translateTo": "翻译为",
  "createDoc.translateNow": "翻译",
  "createDoc.translating": "翻译中...",
  "createDoc.translated": "文档翻译成功",
  "createDoc.translateFailed": "翻译失败",
  "verification.status": "验证状态",
  "verification.inProgress": "验证进行中",
  "verification.getVerified": "获得验证",
  "verification.cancelRequest": "取消请求",
  "verification.submit": "提交验证",
  "verification.submitting": "提交中...",
  "verification.uploadDocs": "上传文档",
  "verification.level": "验证级别",
  "verification.selectDocType": "选择文档类型...",
  "contracts.generate": "生成",
  "contracts.backToTemplates": "返回模板",
  "contracts.required": "必填",
  "contracts.modify": "修改",
  "contracts.finalize": "定稿",
  "contracts.applyChanges": "应用更改",
  "contracts.confirmDelete": "删除此草稿？",
  "contracts.generating": "正在生成文档...",
  "templates.deleting": "删除中...",
  "templates.noDescription": "暂无描述。",
  "templates.use": "使用",
  "templates.lib.ndaMutual": "双向保密协议",
  "templates.lib.purchaseAgreement": "采购协议",
  "templates.lib.serviceAgreement": "服务协议",
  "templates.lib.priceQuote": "报价单",
  "templates.lib.invoice": "发票",
  "templates.lib.loi": "意向书",
  "settings.security": "安全",
  "security.twoFactor": "双重认证",
  "security.enabled": "已启用",
  "security.disabled": "已禁用",
  "security.enable2FA": "启用2FA",
  "security.disable": "禁用",
  "security.activeSessions": "活跃会话",
  "security.logoutAll": "全部登出",
  "security.loginHistory": "登录历史",
  "security.verify": "验证",
  "security.cancel": "取消",
  "security.password": "密码",
  "security.done": "完成",
  "feedback.button": "反馈",
  "feedback.title": "发送反馈",
  "feedback.typeBug": "错误",
  "feedback.typeFeature": "功能",
  "feedback.typeGeneral": "一般",
  "feedback.submit": "提交",
  "feedback.thanks": "谢谢！我们会处理的。",
};

export default zhCN;
